import { useState } from "react";
import { useLocation } from "react-router-dom";
import { getLanguageAlternate } from "@/utils/routes";
import { SiteHeader } from "@/components/luminous/SiteHeader";

interface HeaderProps {
  language: "es" | "en";
  onLanguageChange: (lang: "es" | "en") => void;
}

/**
 * Cabecera compartida del sitio. Delega en la cabecera de la dirección
 * luminosa para que la Home y las páginas interiores usen la misma pieza.
 * El idioma se sigue derivando de la URL: el enlace alterno apunta a la URL
 * equivalente real, sin crear redirects ni cambiar URLs existentes.
 */
export const Header = ({ language }: HeaderProps) => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const altUrl = getLanguageAlternate(pathname, language === "es" ? "en" : "es");

  return <SiteHeader open={open} onOpenChange={setOpen} language={language} altUrl={altUrl} />;
};

export default Header;
